import { Calculator, TrendingUp, HelpCircle } from 'lucide-react';

export default function Hero({
  onOpenHelp,
  onOpenInverse,
  onStart,
  isPremium = false,
}: {
  onOpenHelp?: () => void;
  onOpenInverse?: () => void;
  onStart?: () => void;
  isPremium?: boolean;
}) {
  return (
    <div
      style={{
        background: 'linear-gradient(180deg, rgba(59, 130, 246, 0.08) 0%, rgba(249, 250, 251, 0.35) 55%, rgba(255, 255, 255, 0.9) 100%)',
        borderBottom: '1px solid var(--border)',
        padding: '72px 24px 64px',
        textAlign: 'center',
        maxWidth: '100%',
        position: 'relative'
      }}
    >
      <div
        style={{
          maxWidth: '900px',
          margin: '0 auto'
        }}
      >
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '6px 14px',
            borderRadius: '999px',
            background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.18) 0%, rgba(37, 99, 235, 0.12) 100%)',
            border: '1px solid rgba(16, 185, 129, 0.35)',
            fontSize: '12px',
            fontWeight: 700,
            color: 'var(--brand-ink)',
            margin: '0 0 18px',
            letterSpacing: '0.02em'
          }}
        >
          Simulador 100% actualizado · Normativa 2025/2026
        </div>

        <h1
          style={{
            fontSize: '48px',
            fontWeight: 600,
            lineHeight: '1.15',
            color: 'var(--text)',
            margin: '0 0 20px',
            letterSpacing: '-0.035em'
          }}
        >
          Calcula cuánto te queda como autónomo, sin sorpresas
        </h1>

        {isPremium && (
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '6px 12px',
              borderRadius: '999px',
              background: 'linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(16, 185, 129, 0.16) 100%)',
              border: '1px solid rgba(37, 99, 235, 0.25)',
              fontSize: '12px',
              fontWeight: 700,
              color: 'var(--brand-ink)',
              margin: '0 0 16px',
            }}
          >
            Premium activo
          </div>
        )}

        <p
          style={{
            fontSize: '20px',
            lineHeight: '1.6',
            color: 'var(--muted)',
            margin: '0 0 32px',
            fontWeight: 400,
            maxWidth: '640px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          Calcula tu neto real teniendo en cuenta IRPF, cuota de autónomos e IVA según la normativa aplicable más reciente.
        </p>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '12px',
            flexWrap: 'wrap',
            marginBottom: '12px'
          }}
        >
          <button
            type="button"
            onClick={onStart}
            aria-label="Empezar cálculo"
            style={{
              padding: '14px 26px',
              background: 'var(--brand)',
              border: 'none',
              borderRadius: '12px',
              color: 'white',
              fontSize: '15px',
              fontWeight: 700,
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 10px 24px rgba(37, 99, 235, 0.3)',
              minWidth: '200px'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = 'var(--brand-ink)';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = 'var(--brand)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Empezar cálculo
          </button>
          <button
            type="button"
            onClick={onOpenInverse}
            aria-label="Abrir calculadora inversa"
            style={{
              padding: '14px 22px',
              background: 'white',
              border: '1px solid rgba(37, 99, 235, 0.4)',
              borderRadius: '12px',
              color: 'var(--brand-ink)',
              fontSize: '14px',
              fontWeight: 700,
              cursor: 'pointer',
              transition: 'all 0.2s',
              minWidth: '200px'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = 'rgba(59, 130, 246, 0.08)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = 'white';
            }}
          >
            Quiero cobrar X al mes
          </button>
        </div>

        <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '24px' }} />

        {onOpenHelp && (
          <button
            onClick={onOpenHelp}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 24px',
              background: 'white',
              border: '2px solid #2563eb',
              borderRadius: '8px',
              color: '#2563eb',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 2px 8px rgba(37, 99, 235, 0.1)'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = '#2563eb';
              e.currentTarget.style.color = 'white';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = 'white';
              e.currentTarget.style.color = '#2563eb';
            }}
          >
            <HelpCircle size={18} />
            Guía rápida y glosario
          </button>
        )}
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '1px',
          background: 'linear-gradient(90deg, transparent 0%, var(--border) 50%, transparent 100%)'
        }}
      />
    </div>
  );
}

function FeatureCard({ icon: Icon, title, description }: { icon: any; title: string; description: string }) {
  return (
    <div
      style={{
        padding: '12px 14px',
        background: 'rgba(255, 255, 255, 0.9)',
        borderRadius: '10px',
        border: '1px solid rgba(226, 232, 240, 0.9)'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
        <div
          style={{
            padding: '8px',
            background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Icon size={20} color="#2563eb" />
        </div>
        <div style={{ flex: 1 }}>
          <h4 style={{ margin: '0 0 4px', fontSize: '13px', fontWeight: 700, color: '#1e293b' }}>
            {title}
          </h4>
          <p style={{ margin: 0, fontSize: '12px', lineHeight: '1.4', color: '#64748b' }}>
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}
